import Ajax from '../../../../common/js/Ajax.js';
import Form from '../../../../common/js/form/Form.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import UrlParser from '../../../../common/js/UrlParser.js';
import Widget from '../../../../common/js/Widget.js';

export default class FinishPasswordResetWidget extends Widget {

	constructor($widget) {
		super($widget);
		this.token = UrlParser.getParams()['token'];

		Form.onSubmit(this.$widget, action => {
			var $password1 = action.findField('password');
			var $password2 = action.findField('password2');
			if ($password1.val() !== $password2.val()) {
				Form.showFieldError({
					$field: $password2,
					short: 'Passwords do not match.',
					long: 'The passwords do not match.'
				});
				action.error();
				return;
			}

			Ajax.rpc('/finish-password-reset', {
				token: this.token,
				password: $password1.val()
			}, success => {
				if (success) {
					action.$button.remove();
					action.ok('Perfect. The password has been reset. You can now [login again|/].');
				} else {
					action.error('That wasn\'t successful unfortunately. Do you want to [try again|/forgot-password]?');
				}
			}, error => {
				MessageUtils.error(this.$widget,
					'Oh, das hat leider grad nicht geklappt, bitte versuch es später noch einmal', error);
			});
		});
	}

}
